<template>
<v-app>
<v-main>

<v-container>

    <div
        v-if="show_instructions_ipad"
    >
        <h1>How to Add RedChirp to your iPad's home screen</h1>
        <p>Make sure that you are using <b>Safari</b>.  These instructions will only work in Safari.</p>
        <p>Click the "share" icon (it is in the url bar on the top of the screen)</p>
        <p><img src="@/assets/ios-icon-step1-ipad.png" width="700"/></p>
        <p>Click "Add to Home Screen"</p>
        <p><img src="@/assets/ios-icon-step2.png" width="300"/></p>
    </div>

    <div
        v-if="show_instructions_iphone"
    >
        <h1>How to Add RedChirp to your iPhone's home screen</h1>
        <p>Make sure that you are using <b>Safari</b>.  These instructions will only work in Safari.</p>
        <p>If the share icon is not visible at the bottom of your screen, click on the bar near the bottom of your screen that shows the lock icon followed by app.redchirp.com</p>
        <p><img src="@/assets/ios-iphone-bottom-chin.png" width="450"/></p>
        <p>Click the "share" icon (it is in center of the bottom button bar)</p>
        <p><img src="@/assets/ios-icon-step1-iphone.png" width="500"/></p>
        <p>Click "Add to Home Screen"</p>
        <p><img src="@/assets/ios-icon-step2.png" width="300"/></p>
    </div>

    <v-btn
        v-on:click="onClickGoBack"
    >
        Go Back
    </v-btn>


</v-container>
</v-main>
</v-app>
</template>

<script>
export default {
    data() {
        return {
        }
    },

    mounted () {
    },

    beforeRouteEnter(to, from, next) {
        if ( from.name != 'ios-to-instructions' )
        {
            next('/app/home');
        }
        
        next(vm => {});
    },

    methods: {
        onClickGoBack() {
            this.$router.go(-1);
        }
    },

    computed: {
        show_instructions_ipad() 
        {
            if ( this.$rc.isIPad() )
                return true;

            if ( !this.$rc.isIPhone() )
                return true;

            return false;
        },

        show_instructions_iphone() 
        {
            if ( this.$rc.isIPhone() )
                return true;

            if ( !this.$rc.isIPad() )
                return true;

            return false;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>